/**
* CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.to( '.cta__parallax-img', {
        yPercent: -50,
        ease: 'none',
        scrollTrigger: {
          trigger: '.cta',
          start: 'top 35%',
          end: 'bottom top',
          // markers: true,
          scrub: 0.5,
        },
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'cta', COMPONENT );
} )( app );
